(function() {
    'use strict';

    angular.module('format', [
            'ui.router',
            'format.services',
            'format.constants'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'formatGroupPermissionsConst', 'formatPermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, formatGroupPermissionsConst, formatPermissionsConst) {

        $stateProvider
            .state('layout.formatGroup', {
                abstract: true,
                url: '/format-group',
                data: {
                    title: 'Grupy formatów',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.formatGroup.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/format/views/group-list/group-list.html',
                        controller: 'FormatGroupListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: formatGroupPermissionsConst.view
                }
            })
            .state('layout.formatGroup.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/format/views/group-create/group-create.html',
                        controller: 'FormatGroupCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: formatGroupPermissionsConst.add
                }
            })
            .state('layout.formatGroup.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/format/views/group-update/group-update.html',
                        controller: 'FormatGroupUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: formatGroupPermissionsConst.update
                }
            })
            .state('layout.formatGroup.detail', {
                url: '/detail/:pk',
                data: {
                    title: 'Formaty',
                    modelPermission: formatPermissionsConst.view
                },
                views: {
                    'main@layout': {
                        templateUrl: 'app/format/views/group-detail/group-detail.html',
                        controller: 'FormatGroupDetailController',
                        controllerAs: 'ctrl'
                    }
                }
            });

        $stateProvider
            .state('layout.format', {
                abstract: true,
                url: '/format',
                data: {
                    title: 'Formaty',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.format.list', {
                url: '/list?with_group',
                views: {
                    'main@layout': {
                        templateUrl: 'app/format/views/format-list/format-list.html',
                        controller: 'FormatListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: formatPermissionsConst.view
                }
            })
            .state('layout.format.create', {
                url: '/create?groupPk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/format/views/format-create/format-create.html',
                        controller: 'FormatCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: formatPermissionsConst.add
                }
            })
            .state('layout.format.update', {
                url: '/update/:pk?groupPk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/format/views/format-update/format-update.html',
                        controller: 'FormatUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: formatPermissionsConst.update
                }
            });
    }
})();
